import React, { ComponentProps } from 'react';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PageLayoutDefaultView } from './views/PageLayoutDefaultView';

type PageLayoutProps = Views<DefaultView<PageLayoutDefaultView>>;
function PageLayout(props: PageLayoutProps) {
  return <PageLayoutDefaultView {...props.views.default} />;
}

export const PageLayoutBlock = asBlock(PageLayout, BlockType.pagelayout);
export type PageLayoutBlock = ComponentProps<typeof PageLayoutBlock>;
